import React from "react";
import andreyPdf from "./assets/andrey.pdf";
import andrey from "./assets/img/Andrey.png";
import "./Lifehacks.scss";

const Lifehacks = () => {
  return (
    <section className="lifehacks" id="lifehacks">
      <div className="container">
        <div className="lifehacks-wrapper">
          <h2 className="section-title lifehacks__title">
            Лайфхаки от блогеров
          </h2>

          <div className="lifehacks-card">
            <div className="lifehacks-card__item">
              <div className="lifehacks-card__item-text">
                <h3 className="name">Андрей Бунбич</h3>
                <span className="post">Кондитер и автор блога «Бунбич»</span>
                <ul className="lifehacks-card__item-list">
                  <span className="lifehacks-card__item-list__title">
                    Скачайте чек-лист из 3 советов о том, как понять:
                  </span>
                  <li>— зачем нужны большие упаковки продуктов</li>
                  <li>— почему одинаковые продукты экологичнее</li>
                  <li>— как большие ящики для вторсырья экономят время</li>
                </ul>

                <a
                  href={andreyPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button button--outlined lifehacks__button"
                >
                  Скачать чек-лист
                </a>
              </div>
              <img className="people-image" src={andrey} alt="Андрей Бунбич" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lifehacks;
